<template lang="pug">
  div
    v-card.px-4.py-2(flat :color="`${$vuetify.theme.themes[$theme].successT16}`")
      v-layout.my-6.px-2.pt-2(v-if="!isFetching && leads.length == 0")
        v-row.fill-height.ma-0(align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/order_mgmt_empty.png')" style="width:80px; height:80px" contain)
            div.p2.basic600--text.text-center {{ $t('no_orders_found') }}
            div.p2.basic600--text.text-center {{ $t('no_orders_adjust_filter') }}
      div(v-else)
        v-card.my-2.elevation-1(v-for="(lead, index) in leads" :key="lead.id" outlined)
          order-item(:parentLead.sync="lead" :menu="menu" @deleted="handleDeletedItem($event)")
      v-layout.my-6.px-2.pt-2(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="3" :size="50" color="basic600" indeterminate)
      div.my-3(v-if="leads.length < totalCount && !isFetching" align="center")
        v-btn.button-AA-small.basic600--text(@click="page++" small rounded) {{ $t('load_more') }}
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import OrderProcessingTop from '@/components/ordermgmt/OrderProcessingTop.vue'
import OrderItem from '@/components/ordermgmt/OrderItem.vue'

export default {
  name: 'KanbanReady',
  components: { OrderProcessingTop, OrderItem },
  props: ['company', 'parentLeads', 'menu', 'statusOrder'],
  data: vm => ({
    isFetching: false,
    searchCountDown: null,
    page: 1,
    fetchCount: 20,
    totalCount: vm.$store.state.ui.pendingOrderCount,
    status: 0
  }),
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({
      view: 'orders/getOrderView',
      filters: 'orders/getFilters',
      search: 'orders/getSearch'
    }),
    leads: {
      get() {
        return this.parentLeads
      },
      set(newValue) {
        this.$emit('update', newValue)
      }
    }
  },
  watch: {
    page(val) {
      if (!this.isFetching) {
        this.fetchLeads(val)
      }
    },
    search() {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.fetchLeads(1)
      }, 500)
    },
    filters: {
      deep: true,
      handler() {
        this.fetchLeads(1)
      }
    },
    '$store.state.orders.leadsVersion'() {
      this.fetchLeads(1)
    },
    statusOrder: {
      deep: true,
      handler() {
        this.fetchLeads(1)
      }
    }
  },
  mounted() {
    this.fetchLeads(1)
  },
  methods: {
    fetchLeads(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let params = new URLSearchParams()
      params.append('page', page)
      params.append('page_size', this.fetchCount)
      params.append('form__company', this.company.id)
      params.append('form_type_exclude', 'book_income')
      params.append('status', 'processed')
      if (this.statusOrder) {
        let readyData = []
        if (this.statusOrder.arranged) {
          readyData.push('arranged')
        }
        if (this.statusOrder.notArranged) {
          readyData.push('not-arranged')
        }
        const data = {
          processing: [],
          ready: readyData
        }
        params.append('order_management_status', JSON.stringify(data))
      } else {
        const data = {
          processing: [],
          ready: ['arranged', 'not-arranged']
        }
        params.append('order_management_status', JSON.stringify(data))
      }
      if (this.search && this.search.length >= 2 && this.search.includes('#')) {
        params.append('rid', this.search.replace('#', ''))
      } else if (this.search) {
        params.append('search', this.search)
      }
      if (this.member.role !== 'Admin') {
        params.append('member', this.member.id)
      }
      if (this.filters.sort === 'oldest') {
        params.append('ordering', 'processed_at')
      } else {
        params.append('ordering', '-processed_at')
      }
      if (this.filters.date && this.filters.range) {
        if (this.filters.date === 'created') {
          if (this.filters.range.dates) {
            if (this.filters.range.dates.length === 1) {
              params.append('processed_at_after', this.filters.range.dates[0])
              params.append('processed_at_before', this.filters.range.dates[0])
            } else {
              if (this.filters.range.dates[0] < this.filters.range.dates[1]) {
                params.append('processed_at_after', this.filters.range.dates[0])
                params.append('processed_at_before', this.filters.range.dates[1])
              } else {
                params.append('processed_at_after', this.filters.range.dates[1])
                params.append('processed_at_before', this.filters.range.dates[0])
              }
            }
          } else {
            if (this.filters.range.value) {
              params.append('processed_at_range', this.filters.range.value)
            }
          }
        } else if (this.filters.date === 'scheduled') {
          if (this.filters.range.dates) {
            if (this.filters.range.dates.length === 1) {
              params.append('asking_delivery_date_after', this.filters.range.dates[0])
              params.append('asking_delivery_date_before', this.filters.range.dates[0])
            } else {
              if (this.filters.range.dates[0] < this.filters.range.dates[1]) {
                params.append('asking_delivery_date_after', this.filters.range.dates[0])
                params.append('asking_delivery_date_before', this.filters.range.dates[1])
              } else {
                params.append('asking_delivery_date_after', this.filters.range.dates[1])
                params.append('asking_delivery_date_before', this.filters.range.dates[0])
              }
            }
          } else {
            if (this.filters.range.value) {
              params.append('asking_delivery_date_range', this.filters.range.value)
            }
          }
        }
      }
      if (this.filters.shipping && Object.keys(this.filters.shipping).length > 0) {
        params.append('fulfilment_method', JSON.stringify(this.filters.shipping))
      }
      if (this.filters.payment && this.filters.payment.length > 0) {
        this.filters.payment.forEach(o => {
          params.append('payment_method', o.value)
        })
      }
      if (this.filters.source && this.filters.source.length > 0) {
        this.filters.source.forEach(o => {
          params.append('form', o.id)
        })
      }
      this.$axios
        .get('/leads/', { params: params })
        .then(response => {
          this.isFetching = false
          if (page > 1) {
            this.leads = [...this.leads, ...response.data.results]
          } else {
            this.leads = [...response.data.results]
          }
          this.totalCount = response.data.count
        })
        .catch(() => {})
    },
    fetchOneLead(leadPid) {
      // Find and update one lead
      const index = this.leads.findIndex(lead => lead.pid === leadPid)
      if (index >= 0) {
        this.$axios
          .get(`/leads/${leadPid}`)
          .then(response => {
            this.leads.splice(index, 1, response.data)
          })
          .catch(() => {})
      }
    },
    handleDeletedItem(item) {
      this.totalCount = this.totalCount - 1
      this.leads = this.leads.filter(x => x.id !== item.id)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.v-sheet--outlined {
  border: thin solid var(--v-basic300) !important;
}
</style>